var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ws-state-images-item"},[(_vm.loading)?_c('WsLoading',[_vm._v(_vm._s(_vm.percent))]):(_vm.url)?_c('img',{attrs:{"max-width":_vm.maxWidth,"src":_vm.url}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }